import React, { useEffect, useState } from "react";
import { UserDocumentVersion } from "../../models/UserDocumentVersion";
import { documentsAPI } from "../../apis";
import { Box, Button, Typography } from "@mui/material";
import { Modes as DialogModes } from "./UserDocumentDialog";
import { UserDocument } from "../../models/UserDocument";
import { displayFormattedDate } from "../../utils/displayDate";

interface Props {
  document: UserDocument;
  setMode: (mode: DialogModes) => void;
  onComplete?: (refresh?: boolean) => void;
  setTempDocument?: (doc?: UserDocument) => void;
}

export const VersionsUserDocument = ({
  document,
  setMode,
  onComplete,
}: Props): JSX.Element => {
  const [versions, setVersions] = useState<UserDocumentVersion[] | undefined>();

  useEffect(() => {
    // onSetTempDoc?.(undefined);
    getVersions();
  }, []);

  const getVersions = async () => {
    document && setVersions(await documentsAPI.getDocumentVersions(document));
  };

  const handleRevert = async (versionId?: number) => {
    document &&
      versionId &&
      (await documentsAPI.revertToDocumentVersion(document, versionId));
    onComplete?.();
    // setRefresh(refresh + 1);
  };

  // const handleViewTempDoc = (version: UserDocumentVersion) => {
  //   const tempDoc = document.clone();
  //   tempDoc.version = version;
  //   setTempDocument?.(tempDoc);
  //   setMode?.(DialogModes.view);
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: 250,
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          textAlign: "center",
          mb: 2,
        }}
      >
        {versions?.map((version: UserDocumentVersion, index: number) => {
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                borderBottom: "solid 1px #ccc",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{
                    width: 20,
                    pr: 1,
                  }}
                >
                  {index + 1}
                </Typography>
                {index !== versions?.length - 1 ? (
                  <Typography color="secondary">
                    {version?.title} ({version?.ext})
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      color: "primary",
                      minWidth: 180,
                      minHeight: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {version.title} ({version?.ext})
                  </Typography>
                )}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body2" sx={{ mr: 1 }}>
                  {displayFormattedDate(version.updatedAt)}
                </Typography>
                {index === versions?.length - 1 ? (
                  <Typography
                    sx={{
                      color: "secondary",
                      minWidth: 180,
                      minHeight: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Current version
                  </Typography>
                ) : (
                  <Button
                    onClick={() => handleRevert(version?.id)}
                    variant="text"
                    color="secondary"
                  >
                    Switch to this version
                  </Button>
                )}
              </Box>
            </Box>
          );
        })}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => setMode(DialogModes.edit)}
        >
          Back to Edit
        </Button>
      </Box>
    </Box>
  );
};
